/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** CreateAuthResetsResponse — dark-roast DTO: StatusOkResponseDto; also used by deleteCertification, deleteEducation */
export const createAuthResetsResponseSchema = z.object({ "status": z.string() });
export type CreateAuthResetsResponse = z.infer<typeof createAuthResetsResponseSchema>;
